// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lang[data-v-6db8f168]{margin-right:16px;width:40px;height:40px;background:hsla(0,0%,84.7%,.1);line-height:38px;text-align:center;border-radius:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
